/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import { addNewRowBankruptcy } from '../../store/ManufacturerAction';

export default (props) => {
  const dispatch = useDispatch();
  const bankruptcyRowData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.bankruptcyList;
  });
  const { commonDropdownList, data } = props;
  const rowIndex =
    bankruptcyRowData?.length > 0 &&
    bankruptcyRowData?.findIndex((x) => {
      return x.id?.toString() === data?.id?.toString();
    });
  const handleChangeSelect = (e) => {
    const newObj = [...bankruptcyRowData];
    const { colId } = props.column;
    const { value } = e.target;
    if (value === '-1' || value === null) {
      props.node.setDataValue(colId, value);
      newObj[rowIndex].bankruptcyTypeCd = value;
      newObj[rowIndex].bankruptcyTypeCdErr = true;
      newObj[rowIndex].addEditRow = true;
      dispatch(addNewRowBankruptcy(newObj, 'verify'));
      props.node.setDataValue(colId, value);
    } else {
      props.node.setDataValue(colId, value);
      newObj[rowIndex].bankruptcyTypeCd = value;
      newObj[rowIndex].bankruptcyTypeCdErr = false;
      newObj[rowIndex].addEditRow = true;
      dispatch(addNewRowBankruptcy(newObj, 'verify'));
      props.node.setDataValue(colId, value);
    }
  };
  return (
    <div data-testid='mfg-select-box' className='frr-type-svg-fix'>
      <TextField
        id='contact_type'
        data-testid='bankruptyTypeCd'
        className={
          bankruptcyRowData &&
          bankruptcyRowData[rowIndex] &&
          bankruptcyRowData[rowIndex].bankruptcyTypeCdErr !== undefined &&
          bankruptcyRowData[rowIndex].bankruptcyTypeCdErr
            ? 'td-active-cell tBill-validate'
            : ''
        }
        fullWidth
        select
        placeholder=''
        inputProps={{ maxLength: 11 }}
        InputLabelProps={{ shrink: true }}
        value={props.value}
        onChange={(e) => {
          handleChangeSelect(e);
        }}
        disabled={!props.isEnablebyRole}
      >
        <MenuItem key='' value='-1' className='frr-dropdown-blank-item' />
        {commonDropdownList?.BANKRUPTCY_TYPE_CD &&
        commonDropdownList?.BANKRUPTCY_TYPE_CD.length > 0
          ? commonDropdownList?.BANKRUPTCY_TYPE_CD.map((item) => {
              return (
                <MenuItem
                  key={item.codeValueID && item.codeValueID.codeValue}
                  value={item.codeValueID && item.codeValueID.codeValue}
                >
                  {`${item.codeValueID && item.codeValueID.codeValue} | ${
                    item.shortDescription
                  }`}
                </MenuItem>
              );
            })
          : null}
      </TextField>
    </div>
  );
};
